import { render } from "./SocialSignUp.vue?vue&type=template&id=21bcd35c&scoped=true"
import script from "./SocialSignUp.vue?vue&type=script&lang=js"
export * from "./SocialSignUp.vue?vue&type=script&lang=js"

import "./SocialSignUp.vue?vue&type=style&index=0&id=21bcd35c&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bcd35c"]])

export default __exports__